
























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class InviteAvaliable extends Vue {
  @Prop() isSelf!: boolean;

  @Prop() isLogged!: boolean;

  @Prop() code!: string;

  @Prop() title!: string;

  accepting = false;

  handleAccept() {
    const isLogged = this.$store.getters["auth/isLogged"];
    if (this.isSelf) {
      return;
    }
    if (isLogged) {
      this.requestSetReferralCode();
      return;
    }
    localStorage.setItem("set_referral_code_immediately", "true");
    this.$common.utils.helper.requestLogin(this);
  }

  async requestSetReferralCode() {
    this.accepting = true;
    try {
      await this.$api.foxone.putReferralCode(this.code);
      await this.$store.dispatch("basis/account/loadAccountData");
      this.$emit("success");
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.accepting = false;
  }
}
export default InviteAvaliable;
